let state = {
    all:               [],
    cachedAll:         [],
    statuses:          [],
    groups:            [],
    ghostGroup:        {},
    absenceTypes:      [],
    slotTitleSettings: [],
    projects:          {},
    tasks:             {},
    fullDayAbsences:   {},
    partDayAbsences:   {},
    weekSchedules:     {},
    updated:           null,
    draggingGroup:     null,
    person:            null,
    canBeManaged:      false,
    planning:          0, // config.PLANNING_ALL
};

export default state;